import React from 'react'
import { useEffect, useState } from 'react';
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import Loader from "react-loader-spinner";
import Swal from "sweetalert2";
import { DecryptED } from "../../DecryptJS/Decrypt";

const UpdateLessonReport = () => {
  const { sid, userid, id } = useParams();
  const [apiloader, setapiLoader] = useState(true);
  const [saving, setSaving] = useState(false);
  const [reports, setReports] = useState({});

  const getReportById = async () => {
    setapiLoader(true);
    try {
      const data = {
        "sid": DecryptED(sid),
        "userId": DecryptED(userid),
        "id": DecryptED(id)
      }
      const response = await axios({
        method: "POST",
        url: `${process.env.REACT_APP_BASE_URL}/api/admin/lessonPlan/reportById`,
        data,
        headers: {
          Authorization: "#$laksdfnlknoea#$@$%^&%$",
        },
      });
      setReports(response.data[0] || {});
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "error",
        title: (error.response && error.response.data && error.response.data.message) || "Could not load the lesson report",
        showConfirmButton: false,
        timer: 5000,
      });
    } finally {
      setapiLoader(false);
    }
  }

  const saveReport = async () => {
    setSaving(true);
    try {
      const payload = {
        ...reports,
        fun_name: "updateLessonplanData",
        staff_id: DecryptED(userid),
        sid: DecryptED(sid),
        id: DecryptED(id),
      };
      const response = await axios.post(
        `https://topschool.prisms.in/rest/index.php/staff_list.json`,
        payload
      );
      if (response.data && response.data.success !== false) {
        Swal.fire({
          position: "center",
          icon: "success",
          title: `Updated successfully!`,
          showConfirmButton: false,
          timer: 1500,
        });
      } else {
        Swal.fire({
          position: "center",
          icon: "warning",
          title: (response.data && response.data.message) || "Some error occured!",
          showConfirmButton: false,
          timer: 1500,
        });
      }
    } catch (error) {
      Swal.fire({
        position: "center",
        icon: "warning",
        title: `Some Error occured!`,
        showConfirmButton: false,
        timer: 1500,
      });
    } finally {
      setSaving(false);
    }
  };

  useEffect(() => {
    getReportById();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [sid, userid, id])

  return (
    <div style={{ backgroundColor: '#f4f6fb', minHeight: '100vh', padding: '24px' }}>
      {apiloader ? (
        <div className="TMLoader">
          <Loader type="ThreeDots" color="#bd2f5e" height={80} width={80} />
        </div>
      ) : (
        <div className='container'>
          <div className='card shadow-sm rounded p-4 bg-white'>
            <h2 style={{ color: '#1f2937', fontWeight: 700 }}>Edit Lesson Report</h2>
            <hr />
            <form className='row' onSubmit={(e) => { e.preventDefault(); saveReport(); }}>

              <div className="col-md-6 mb-3">
                <label htmlFor="lessonObjective">Learning Objectives</label>
                <textarea defaultValue={reports.lesson_objective} onChange={(e) => setReports({ ...reports, lesson_objective: e.target.value })} className="form-control" id="lessonObjective" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="learningOutcome">Learning Outcome</label>
                <textarea defaultValue={reports.learning_outcome} onChange={(e) => setReports({ ...reports, learning_outcome: e.target.value })} className="form-control" id="learningOutcome" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="audioVisualAdis">Audio / Visual Aids</label>
                <textarea defaultValue={reports.audio_visual_adis} onChange={(e) => setReports({ ...reports, audio_visual_adis: e.target.value })} className="form-control" id="audioVisualAdis" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="pedagogicalPractices">Pedagogical Practices</label>
                <textarea defaultValue={reports.pedagogical_practices} onChange={(e) => setReports({ ...reports, pedagogical_practices: e.target.value })} className="form-control" id="pedagogicalPractices" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="teacherPreparation">Teacher Preparation</label>
                <textarea defaultValue={reports.teacher_preparation} onChange={(e) => setReports({ ...reports, teacher_preparation: e.target.value })} className="form-control" id="teacherPreparation" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="studentPreparation">Student Preparation</label>
                <textarea defaultValue={reports.student_preparation} onChange={(e) => setReports({ ...reports, student_preparation: e.target.value })} className="form-control" id="studentPreparation" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="additionalExtended">Additional Extended Information</label>
                <textarea defaultValue={reports.additional_extended_information} onChange={(e) => setReports({ ...reports, additional_extended_information: e.target.value })} className="form-control" id="additionalExtended" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="interdisciplinaryLinkage">Interdisciplinary Linkage</label>
                <textarea defaultValue={reports.interdisciplinary_linkage} onChange={(e) => setReports({ ...reports, interdisciplinary_linkage: e.target.value })} className="form-control" id="interdisciplinaryLinkage" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="infusion">Infusion With Life Skills</label>
                <textarea defaultValue={reports.infusion_with_life_skills} onChange={(e) => setReports({ ...reports, infusion_with_life_skills: e.target.value })} className="form-control" id="infusion" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="artIntegration">Art Integration</label>
                <textarea defaultValue={reports.art_integration} onChange={(e) => setReports({ ...reports, art_integration: e.target.value })} className="form-control" id="artIntegration" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="storyBased">Story Based</label>
                <textarea defaultValue={reports.story_based} onChange={(e) => setReports({ ...reports, story_based: e.target.value })} className="form-control" id="storyBased" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="artificialIntelligence">Artificial Intelligence</label>
                <textarea defaultValue={reports.artificial_intelligence} onChange={(e) => setReports({ ...reports, artificial_intelligence: e.target.value })} className="form-control" id="artificialIntelligence" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="fln">FLN</label>
                <textarea defaultValue={reports.fln} onChange={(e) => setReports({ ...reports, fln: e.target.value })} className="form-control" id="fln" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="remedialPlan">Remedial Plan</label>
                <textarea defaultValue={reports.remedial_plan} onChange={(e) => setReports({ ...reports, remedial_plan: e.target.value })} className="form-control" id="remedialPlan" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="cwsnPlan">Cwsn Plan</label>
                <textarea defaultValue={reports.cwsn_plan} onChange={(e) => setReports({ ...reports, cwsn_plan: e.target.value })} className="form-control" id="cwsnPlan" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="assignment">Assignment</label>
                <textarea defaultValue={reports.assignment} onChange={(e) => setReports({ ...reports, assignment: e.target.value })} className="form-control" id="assignment" ></textarea>
              </div>

              <div className="col-md-6 mb-3">
                <label htmlFor="referenceUsed">Reference Used</label>
                <textarea defaultValue={reports.reference_used} onChange={(e) => setReports({ ...reports, reference_used: e.target.value })} className="form-control" id="referenceUsed" ></textarea>
              </div>
              <div className='col-md-12 d-flex gap-2'>
                <input type='submit' className='btn btn-primary my-0' value={saving ? "Saving…" : "Save"} disabled={saving} />
                <Link to={`/admin/report/${sid}/${userid}/${id}`} className='btn btn-secondary my-0'>Cancel</Link>
              </div>
            </form>
          </div>
        </div>
      )
      }
    </div>
  )
}

export default UpdateLessonReport
